export const PRODUCT_HOT_SALE_TAG = 'PROMORIBBON_HS';
export const PRODUCT_BUEN_FIN_TAG = 'PROMORIBBON_BF';
export const PRODUCT_CYBER_DAYS_TAG = 'PROMORIBBON_CD';
export const PRODUCT_EXCLUSIVE_TAG = 'TAG_EXCLUSIVE';
export const EXCLUSIVE_BRAND_DIY = 'EXCLUSIVE_BRAND_DIY';

export const PDP_ROOMVO_TRIGGER_ESPOT = 'PDP-RoomvoTrigger';
export const PDP_UX_COMPONENT_ESPOT = 'PDP-UXcomponent';
export const PDP_SUPERSKU_HELP_ESPOT = 'PDP-SuperSKU_Help';
export const PDP_CROSS_SELL_ESPOT = 'PDP-CrossSell';

export const PDP_PRICE_SUPERIOR_SECTION_ESPOT = 'PDP-Price_SuperiorSection';
export const PDP_PRICE_INFERIOR_SECTION_ESPOT = 'PDP-Price_InferiorSection';
export const PDP_NOT_AVAILABLE_SKU_ESPOT = 'PDP_NotAvailableSKU_Content';
export const HDM_NOT_AVAILABLE_BODY_CLASS = 'hdm-not-available-body';

export const BASE_COLOR_IDENTIFIER_SUFFIX = 'BASE_';
export { NO_RANGE_INDICATOR } from '@/data/constants/paintColorPalette';
export const NOT_APPLICABLE = 'N/A';
export const WHITE_BASE_COLOR_NAME = 'Blanca';
export const MEDIUM_BASE_COLOR_NAME = 'Media';
export const DEEP_BASE_COLOR_NAME = 'Deep';

export enum PRODUCT_TAGS_LABELS {
	HOT_SALE = 'HotSaleProductTag',
	BUEN_FIN = 'BuenFinProductTag',
	CYBER_DAYS = 'CyberDaysProductTag',
	EXCLUSIVE = 'ExclusiveProductTag',
}

export const CORA_BUNDLE_AR_JS = 'https://cora.accenture.com/widget/cora-ar-web/cora-bundle.min.js';
export const AR_APITOKENKEY = 'AR_APITOKENKEY';
export const ENABLE_AR = 'ENABLE_AR';

export const PDP_MSI_UPPER_ESPOT = 'PDP-MSI_Drawer_SuperiorSection';
export const PDP_MSI_LOWER_ESPOT = 'PDP-MSI_Drawer_InferiorSection';
export const PDP_MSI_MIDDLE_ESPOT = 'PDP_MSI';

export const ROOMVO_SCRIPT_TAG_ID = 'roomvo-script';
export const ROOMVO_SCRIPT = 'https://cdn.roomvo.com/static/scripts/b2b/homedepot_mexico.js';

export const VISUAL_SUPPORT_ATTRIBUTE_IDENTIFIER = 'VISUALIZACION_INTELIGENTE';
export const AR_VISUAL_SUPPORT_VALUE = 'Realidad aumentada';
export const ROOMVO_VISUAL_SUPPORT_VALUE = 'Probador virtual';

export const NAVIGATION_BAR_ID = 'hdm-pdp-navigation-bar';
export const PRODUCT_BAR_ID = 'hdm-pdp-product-bar';

export const NAVIGABLE_SECTION_CLASS_NAME = 'navigable-section';
export const NAVIGABLE_ACCORDION_SECTION_CLASS_NAME = 'navigation-accordion-section';
export const NAVIGABLE_SECTION_ID_ATTRIBUTE = 'data-navigable-section-id';

export enum NAVIGABLE_SECTION_IDS {
	PRODUCT_DETAILS = 'PRODUCT_DETAILS',
	PRODUCT_SPECS = 'PRODUCT_SPECS',
	PRODUCT_COMPARE = 'PRODUCT_COMPARE',
	PRODUCT_REVIEWS = 'PRODUCT_REVIEWS',
	PRODUCT_BUY_BY_COLOR = 'PRODUCT_BUY_BY_COLOR',
	PRODUCT_ADDITIONAL_INFO = 'PRODUCT_ADDITIONAL_INFO',
	PRODUCT_QUESTIONS = 'PRODUCT_QUESTIONS',
}

export const SCROLL_TO_NAVIGABLE_ACCORDION_SECTION_EVENT = 'scroll-to-navigable-accordion-section';

// Gap between the navigation bar and the target section when scrolling
export const SCROLL_TO_NAVIGABLE_SECTION_SPACING = 8;
